import { Link } from "react-router-dom";
import { getToken } from "../utils/auth";

export default function Confirmacion() {
  const token = getToken();

  return (
    <main>
      <div className="grid-confirmacion site-width">
        <img src="/images/boton-de-verificacion.svg" alt="Icono" />
        <div className="texto-confirmacion">
          <h2>Cita confirmada</h2>
          {token ? (
            <>
              <p>Tu cita ha sido confirmada. Puedes gestionarla desde tu <Link to="/dashboard">panel de usuario</Link>.</p>
              <br />
              <p>¡Gracias! ¡Nos vemos pronto! ;)</p>
            </>
          ) : (
            <>
              <p>
                Tu cita ha sido confirmada. Recuerda que puedes administrar tus
                citas <Link to="/login">iniciando sesión</Link> con el número de teléfono que
                reservaste.
              </p>
              <br />
              <p>¡Gracias! ¡Nos vemos pronto! ;)</p>
            </>
          )}
        </div>
      </div>
    </main>
  );
}
